import $ from 'jquery';
import templateContent from '../util/template_content';
import { initTooltips } from '@/js/modules/tooltips';
import { addClearDateButton } from '@/js/modules/jquery_datepicker_clear_button';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { isMobile } from '@/js/modules/viewport';
import { debounce } from '@/js/util';
import { queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';
import '@/js/modules/jquery_datepicker_defaults';

// The trackables list's infinite scroll, set up on the order tracker page.
let infiniteScrollObserver;

onPageLoad(() => {
  if ($('#order-tracker-all-dates-template').length > 0) {
    const allFieldsCheckbox = document
      .getElementById('order-tracker-all-dates-template')
      .content.querySelector('div');

    $('.field--order-tracker-date').datepicker({
      beforeShow(input, calendar) {
        setTimeout(() => {
          addClearDateButton(input);
          const headerIndex = $(input).closest('td').index();
          const trackableItemId = $(input).closest('tr').data('trackable-item-id');
          const trackablePoId = $(input).closest('tr').data('trackable-po-id');

          const currentRow = input.closest('tr');
          const previousRow = currentRow.previousElementSibling;
          const nextRow = currentRow.nextElementSibling;

          if (!previousRow && !nextRow) {
            return;
          }

          if (!previousRow && nextRow) {
            if (nextRow.classList.contains('order-tracker-form-table__source-row')) {
              return;
            }
          }

          if (previousRow && !nextRow) {
            if (previousRow.classList.contains('order-tracker-form-table__source-row')) {
              return;
            }
          }

          if (previousRow && nextRow) {
            if (
              previousRow.classList.contains('order-tracker-form-table__source-row') &&
              nextRow.classList.contains('order-tracker-form-table__source-row')
            ) {
              return;
            }
          }

          $(allFieldsCheckbox)
            .find('#order-tracker-all-dates-checkbox')
            .attr('data-trackable-item-id', trackableItemId)
            .attr('data-trackable-po-id', trackablePoId)
            .attr('data-header-index', headerIndex);

          calendar.dpDiv.append(allFieldsCheckbox);

          if (trackablePoId) {
            $('.order-tracker-all-dates__label-description').text('fields for this PO.');
          } else {
            $('.order-tracker-all-dates__label-description').text('in this vendor group.');
          }

          $(input).addClass('field--order-tracker-date-selected');
          const headerText = $(input)
            .closest('.order-tracker-form-table')
            .find('thead')
            .find(`th:nth-child(${headerIndex + 1})`)
            .text();
          $('.order-tracker-all-dates__label-name').text(headerText);

          if (input.value === '') {
            $('#order-tracker-all-dates-checkbox').attr('disabled', true);
          }
        }, 10);
      },
      onChangeMonthYear: (_year, _month, calendar) => {
        addClearDateButton(calendar.input[0]);
      },
      onSelect(date, calendar) {
        $(this)
          .closest('.order-tracker-form-table__td')
          .removeClass('order-tracker-form-table__td--inactive')
          .find('.field--order-tracker-date')
          .removeClass('field--order-tracker-date-selected');

        if ($('#order-tracker-all-dates-checkbox').is(':checked')) {
          const tdIndex = $(calendar.input).closest('td').index();
          const $td = $(this)
            .parents('.order-tracker-form-table')
            .find(`td:nth-child(${tdIndex + 1})`);
          $td.find('.field--order-tracker-date').val(date).data('old-value', date);
          const $form = $td.find('form').first();

          $form.append('<input type="hidden" value="1" name="update_all">');

          $form.trigger('submit');

          $form.find('input[name="update_all"]').remove();

          $('#order-tracker-all-dates-checkbox').prop('checked', false);
        } else {
          $(this).attr('data-old-value', $(this).val());
          $(this).attr('value', date);

          const $form = $(this).parent();
          $form.submit();
        }

        if (
          calendar.dpDiv[0] &&
          calendar.dpDiv[0].querySelector('label.order-tracker-all-dates__label')
        ) {
          setTimeout(function () {
            $(calendar.input).datepicker('show');
          }, 0);

          $('#order-tracker-all-dates-checkbox').attr('disabled', false);
        }
      },
      onClose() {
        $('.field--order-tracker-date-selected').removeClass('field--order-tracker-date-selected');
        $('#order-tracker-all-dates-checkbox').prop('checked', false);
        $('.field--order-tracker-date').blur();
      },
    });
  }
  $(document).on('change', '#order-tracker-all-dates-checkbox', (e) => {
    if ($(e.target).is(':checked')) {
      const trackableItemId = $(e.target).attr('data-trackable-item-id');
      const trackablePoId = $(e.target).attr('data-trackable-po-id');
      const headerIndex = parseInt($(e.target).attr('data-header-index'));
      const $tr = $(`tr[data-trackable-item-id=${trackableItemId}]`);
      const date = $tr
        .find(`td:nth-child(${headerIndex + 1})`)
        .find('.field--order-tracker-date')
        .val();
      if (date.length) {
        openApplyDateToAllModal($tr, date, headerIndex, trackableItemId, trackablePoId);
      }
    }
  });
  $(document).on('change', '#enable_tracker_in_client_view', (e) => {
    const enableTrackerInClientView = $(e.target).is(':checked');
    const projectId = parseInt($('meta[name=project-id]').attr('content'));
    const isLegacyPlan = $('meta[name=legacy-plan]').attr('content') === 'true';

    if (isLegacyPlan) {
      window.location.href = '/legacy_upgrade';
      return;
    }

    // scroll to the right to show the last column & add shadow to indicate it can be scrolled
    $('.order-tracker-form-table-container').scrollLeft(1000);
    $('.order-tracker-form-table__td--sticky').addClass(
      'order-tracker-form-table__td--sticky-shadow'
    );

    $.post(`/projects/${projectId}/xhr_toggle_enable_tracker_in_client_view`, {
      enable_tracker_in_client_view: enableTrackerInClientView,
    }).done(() => {
      const $shareViaLinkBtn = $('.dropdown-button__item--share-via-link');
      if (!$shareViaLinkBtn.length) {
        return;
      }

      $shareViaLinkBtn.toggleClass(
        'dropdown-button__item--share-via-link--hidden',
        !enableTrackerInClientView
      );
    });
  });

  function openApplyDateToAllModal($tr, dateToApply, headerIndex, trackableItemId, trackablePoId) {
    const dateElems = $tr[0]
      .closest('tbody')
      .querySelectorAll(`tr td:nth-child(${headerIndex + 1}) .field--order-tracker-date`);
    const itemElems = $tr[0]
      .closest('tbody')
      .querySelectorAll('tr td:nth-child(1) .order-tracker-form-table__item-title');
    const columnText = $tr[0]
      .closest('table')
      .querySelector(`thead tr th:nth-child(${headerIndex + 1})`).textContent;
    const columnName = columnText.toLowerCase().endsWith('date')
      ? `${columnText}`
      : `${columnText} date`;

    const listItems = Array.from(itemElems).reduce((acc, itemElem, idx) => {
      const itemName = itemElem.textContent;
      const currentRow = itemElem.closest('tr');
      if (currentRow === $tr[0]) {
        return acc;
      }

      const currentDate = dateElems[idx].value;
      if (currentDate === dateToApply) {
        return acc;
      }

      if (trackablePoId && trackablePoId !== currentRow.dataset.trackablePoId) {
        return acc;
      }

      if (currentDate) {
        acc.push(`<li>${itemName} currently has an ${columnName} of ${currentDate}</li>`);
      } else {
        acc.push(`<li>${itemName} currently doesn't have ${columnName} assigned`);
      }
      return acc;
    }, []);
    const htmlToInsert = listItems.join('');
    const modal = templateContent(document.getElementById('order-tracker-apply-date-template'));
    modal.querySelector('[data-apply-date-list]').innerHTML = htmlToInsert;
    modal.querySelector('[data-apply-date-question]').textContent =
      `Are you sure you want to apply this date to all '${columnText}' items?`;
    modal
      .querySelector('[data-apply-date-confirm]')
      .addEventListener('click', () =>
        applyDateToAll(dateToApply, trackableItemId, trackablePoId, headerIndex)
      );
    // Closing the datepicker unticks "Apply date to ALL" and blurs the date field, so the dialog
    // doesn't hand focus back to the field (which would reopen the datepicker) when it closes.
    $('.field--order-tracker-date').datepicker('hide');
    document.body.append(modal);
  }
  function applyDateToAll(dateToApply, trackableItemId, trackablePOId, headerIndex) {
    const $tr = $(`tr[data-trackable-item-id=${trackableItemId}]`);
    let $td = null;
    if (trackablePOId) {
      $td = $tr
        .parents('.order-tracker-form-table')
        .find(`tr[data-trackable-po-id=${trackablePOId}]`)
        .find(`td:nth-child(${headerIndex + 1})`);
    } else {
      $td = $tr.parents('.order-tracker-form-table').find(`td:nth-child(${headerIndex + 1})`);
    }
    const $form = $td.find('form').first();

    $td.find('.field--order-tracker-date').val(dateToApply).data('old-value', dateToApply);

    $form.append('<input type="hidden" value="1" name="update_all">');
    $('.field--order-tracker-date').blur();

    $form.trigger('submit');

    $form.find('input[name="update_all"]').remove();
  }
  $(document).ready(function () {
    $('.field--order-tracker-date').blur();
    toggleOrderTrackerTableShadows('.order-tracker-form-table-container');

    if (window.location.hash.length >= 2) {
      if (window.location.hash.match('po-')) {
        scrollToFirstPoId(window.location.hash.slice(4));
      } else {
        scrollToOrderTrackerItemId(window.location.hash.slice(1));
      }
    }

    // clone po headers for each vendor and place them in a overview container
    $('.order-tracker__vendor').each((_i, vendorCont) => {
      const $vendorCont = $(vendorCont);
      const $overviewCont = $vendorCont.find('.order-tracker-header__overview');

      if ($overviewCont.length === 0) {
        return;
      }
      const overviewRows = [];
      $vendorCont
        .find('.order-tracker-form-table__source-row--purchase-order ul')
        .each((_i, poHeader) => {
          const newRow = document.createElement('tr');

          if (!poHeader.children) {
            return;
          }
          [...poHeader.children].forEach((item) => {
            const newCell = document.createElement('td');

            newCell.innerHTML = item.innerHTML;

            newRow.appendChild(newCell);
          });

          overviewRows.push(newRow);
        });
      $overviewCont.append(overviewRows);
    });
  });
  $(document).on('blur', '.field--order-tracker-date', (e) => {
    if ($(e.target).val() !== '') {
      $(e.target).addClass('field--order-tracker-date-filled');
    } else {
      $(e.target).removeClass('field--order-tracker-date-filled');
    }
  });

  $(document).on('click', '.order-tracker-all-dates', () => {
    $('.field--order-tracker-date-selected').focus();
  });

  $(document).on('click', '.order-tracker-header, .order-tracker-header__fold-icon', (e) => {
    if ($(e.target).hasClass('order-tracker-header__item-id')) {
      return true;
    }
    if ($(e.target).hasClass('h-s-button--order-tracker-attachment')) {
      return false;
    }
    if ($(e.target).closest('[data-controller~="ui--twin-turbo-modal-trigger"]').length) {
      return true;
    }

    const $targetEl = $(e.target);
    const $headerCont = $targetEl.hasClass('order-tracker-header')
      ? $targetEl
      : $targetEl.closest('.order-tracker-header');

    const $foldIcon = $headerCont
      .closest('.order-tracker__vendor')
      .find('.order-tracker-header__fold-icon');
    const $orderTrackerTable = $headerCont
      .closest('.order-tracker-header')
      .siblings('.order-tracker-form-table-container');
    const $orderTrackerScroll = $headerCont
      .closest('.order-tracker-header')
      .siblings('.top-scrollbar');
    const $overviewCont = $headerCont.find('.order-tracker-header__overview');

    $foldIcon.toggleClass('order-tracker-header__fold-icon--closed');
    $orderTrackerTable.toggleClass('hide');
    $orderTrackerScroll.toggleClass('hide');
    $overviewCont.toggleClass('hide');

    if ($(e.target).hasClass('order-tracker-header__fold-icon')) {
      return false;
    }
  });

  $(document).on(
    'click',
    '.h-s-button--toggle-order-tracker-delivered:not(.login-required)',
    (e) => {
      e.preventDefault();

      const projectId = parseInt($('meta[name=project-id]').attr('content'));
      const $markDeliveredBtn = $(e.target);
      const orderTrackerItemId = $markDeliveredBtn.data('order-tracker-item-id');
      const markDeliveredUrl = `/projects/${projectId}/order_tracker/xhr_toggle_marked_delivered_date`;

      $markDeliveredBtn
        .toggleClass('h-s-button--delivered')
        .toggleClass('h-s-button--mark-delivered');

      const data = {
        id: orderTrackerItemId,
        marked_delivered: $markDeliveredBtn.hasClass('h-s-button--delivered'),
      };

      $.post(markDeliveredUrl, data).done((res) => {
        if (res['marked_delivered']) {
          updateTextOnly($markDeliveredBtn, 'Item Delivered');
          $(`.order-tracker-table__progressbar-label-${orderTrackerItemId}`).text('Delivered:');
          $(`.order-tracker-table__progressbar-label--delivered-${orderTrackerItemId}`).text(
            res['formatted_delivered_date']
          );
          $(
            `.order-tracker-table__tr-${orderTrackerItemId} .order-tracker-table__progressbar-block`
          ).addClass('completed-all');
        } else {
          updateTextOnly($markDeliveredBtn, 'Mark Delivered');
          $(`.order-tracker-table__progressbar-label-${orderTrackerItemId}`).text('Est. Delivery:');
          $(`.order-tracker-table__progressbar-label--delivered-${orderTrackerItemId}`).text(
            $(`.order-tracker-table__progressbar-label--delivered-${orderTrackerItemId}`).data(
              'deliver-date'
            )
          );
          $(
            `.order-tracker-table__tr-${orderTrackerItemId} .order-tracker-table__progressbar-block`
          ).removeClass('completed-all');
        }
      });
    }
  );

  $(document).on('focus', '.order-tracker-form-table__note, .field--order-tracker-date', (e) => {
    $('.order-tracker-form-table__td--active').removeClass('order-tracker-form-table__td--active');
    $(e.target)
      .closest('.order-tracker-form-table__td')
      .removeClass('order-tracker-form-table__td--inactive')
      .addClass('order-tracker-form-table__td--active');
  });

  $(document).on(
    'blur change',
    '.order-tracker-form-table__note, .field--order-tracker-date',
    (e) => {
      const $el = $(e.target);
      const $td = $el.closest('.order-tracker-form-table__td');
      const $orderTrackerNote = $td.find('.order-tracker-form-table__note');
      const $orderTrackerDate = $td.find('.field--order-tracker-date');
      $td.removeClass('order-tracker-form-table__td--active');
      if ($orderTrackerNote.val() === '' && $orderTrackerDate.val() === '') {
        $td.addClass('order-tracker-form-table__td--inactive');
      } else {
        $td.removeClass('order-tracker-form-table__td--inactive');
      }

      if (
        e.type === 'focusout' &&
        ($el.hasClass('order-tracker-form-table__note') ||
          ($el.hasClass('field--order-tracker-date') && !$el.val()))
      ) {
        if ($el.data('old-value') === undefined) {
          $el.data('old-value', '');
        }
        if ($el.data('old-value') !== $el.val()) {
          $el.data('old-value', $el.val());
          const $form = $el.parent();
          $form.submit();
        }
      }
    }
  );

  const submitNoteDebounced = debounce((el) => {
    // this is copy of what we have in blur change listener
    if (el.data('old-value') === undefined) {
      el.data('old-value', '');
    }

    if (el.data('old-value') !== el.val()) {
      el.data('old-value', el.val());

      const $form = el.parent();

      $form.submit();
    }
  });

  $(document).on('input', '.order-tracker-form-table__note', (e) => {
    const $el = $(e.target);

    submitNoteDebounced($el);
  });

  const orderTrackerTablesAnchored = [];

  // anchor the PO header to the top of the table when scrolling
  function anchorOrderTrackerHeader() {
    const $tableHeaders = $('.order-tracker-header');
    const headerHeight = $('.header').height();
    const mobileOffset = isMobile() ? 60 : 0;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    $tableHeaders.each((index, el) => {
      const $tableHeader = $(el);
      const $orderTrackerParent = $tableHeader.closest('.order-tracker__vendor');
      const $currentTableHeader = $orderTrackerParent.find('.order-tracker-form-table thead');
      const $table = $tableHeader.siblings('.order-tracker-form-table-container');
      const tableHeaderScrollTop = $table.length ? $table.offset().top : 0;
      const tableHeaderHeight = $tableHeader.outerHeight();
      const $products = $table.find('.order-tracker-form-table__td--item');
      const $lastProduct = $products.last();
      const headerDistance = tableHeaderScrollTop - tableHeaderHeight - headerHeight - mobileOffset;
      const lastProductOffset = $lastProduct.length ? $lastProduct.offset().top : 0;
      const endOfTableDistance = lastProductOffset - headerHeight - mobileOffset;
      const translateTop =
        window.scrollY - headerDistance + $('.top-scrollbar').outerHeight() - mobileOffset;
      const $currentAnchoredHeader = $orderTrackerParent.find('.order-tracker-header--anchored');

      orderTrackerTablesAnchored[index] = false;

      if (
        window.scrollY > headerDistance &&
        window.scrollY < endOfTableDistance &&
        $products.length > 0 &&
        $table.css('display') !== 'none'
      ) {
        // anchore header and scloolbar
        // avoid anchoring header on safari due to safari bug
        if (isSafari === false) {
          $currentTableHeader.addClass('order-tracker-form-table__anchored-thead').css({
            translate: `0 ${translateTop}px`,
          });
          $orderTrackerParent.find('.top-scrollbar').css({
            boxShadow: '0 20px 0 0 #fafbfb, 0 40px 0 0 #fafbfb',
          });
        }
        $orderTrackerParent
          .find('.top-scrollbar')
          .addClass('top-scrollbar--anchored')
          .css({
            translate: `0 ${translateTop}px`,
          });

        orderTrackerTablesAnchored[index] = true;
      }

      if (orderTrackerTablesAnchored[index] && !$currentAnchoredHeader.length) {
        $tableHeader
          .clone()
          .addClass('order-tracker-header--anchored')
          .appendTo($orderTrackerParent);
      }

      if (!orderTrackerTablesAnchored[index] && $currentAnchoredHeader.length) {
        $currentTableHeader.removeClass('order-tracker-form-table__anchored-thead').css({
          translate: '0 0',
        });

        $orderTrackerParent.find('.top-scrollbar').removeClass('top-scrollbar--anchored').css({
          translate: '0 0',
          boxShadow: 'none',
        });

        $currentAnchoredHeader.remove();
      }
    });
  }

  // detect horizontal scroll to toggle left/right shadows as needed
  function toggleOrderTrackerTableShadows(container) {
    const $tableContainer = $(container);
    const $tableFixedColumns = $tableContainer.find('.order-tracker-form-table__td--sticky');
    const innerTableWidth = $tableContainer.find('.order-tracker-form-table').width();
    const outerContainerWidth = $tableContainer.width();

    // calculate maxScrollWidth based on container and inner table widths
    const maxScrollWidth = innerTableWidth - outerContainerWidth;

    if (maxScrollWidth === 0) {
      // hide shadows if the table has no scroll (widescreens)
      $tableContainer.removeClass('order-tracker-form-table-container--shadow');
      $tableFixedColumns.removeClass('order-tracker-form-table__td--shadow');
    } else {
      if ($tableContainer.scrollLeft() === 0) {
        // if we're at the left side, hide the shadow on the columns (left)
        $tableContainer.addClass('order-tracker-form-table-container--shadow');
        $tableFixedColumns.removeClass('order-tracker-form-table__td--shadow');
      } else if ($tableContainer.scrollLeft() + 1 > maxScrollWidth) {
        // if at the right side, hide the shadow on the container (right)
        $tableContainer.removeClass('order-tracker-form-table-container--shadow');
        $tableFixedColumns.addClass('order-tracker-form-table__td--shadow');
      } else {
        // show shadows on both sides while scrolling
        $tableContainer.addClass('order-tracker-form-table-container--shadow');
        $tableFixedColumns.addClass('order-tracker-form-table__td--shadow');
      }
    }
  }

  function resizeTopScroll() {
    $('.top-scrollbar__block').width($('.order-tracker-form-table:visible').width());
  }

  function synchronizeScroll(table, scrollLeft) {
    const $correspondingTopScroll = $(table).siblings('.top-scrollbar');
    $(table).scrollLeft(scrollLeft);
    $correspondingTopScroll.scrollLeft(scrollLeft);
  }

  if ($('body').is('#order-tracker-form')) {
    infiniteScrollObserver = new IntersectionObserver((entries) => {
      entries.filter(({ isIntersecting }) => isIntersecting).forEach(() => loadItemsList(false));
    });

    document.addEventListener('scroll', anchorOrderTrackerHeader, { passive: false });

    // this ensures that only two lines are shown for the item title
    $('.order-tracker-form-table__item-title').css('-webkit-box-orient', 'vertical');

    const params = queryString();
    if (Object.keys(params).length && Object.keys(params).includes('billable_id')) {
      const dims = document
        .querySelector(`[data-id="${params['billable_id']}"`)
        .getBoundingClientRect();
      window.scrollTo(window.scrollX, dims.top - 255);
    }

    $('.order-tracker-form-table-container').scroll((e) => {
      toggleOrderTrackerTableShadows(e.target);
      synchronizeScroll(e.target, $(e.target).scrollLeft());
    });

    $('.top-scrollbar').on('scroll', (e) => {
      const $correspondingTable = $(e.target).siblings('.order-tracker-form-table-container');
      synchronizeScroll($correspondingTable, $(e.target).scrollLeft());
    });

    resizeTopScroll();

    $(document).on($.modal.CLOSE, '.modal--trackables-list', (e) => {
      unbindInfiniteScrollOvserver();

      $(e.target).remove();
    });

    $(document).on($.modal.OPEN, '.modal--trackables-list', (e) => {
      bindInfiniteScrollOvserver();
    });

    $(document).on('click', '[data-filter-vendor]', (e) => {
      e.preventDefault();

      const $filterTarget = $('[data-filter-vendor-target]');

      $filterTarget.closest('.filter-list__item').toggleClass('filter-list__item--open');
      $filterTarget
        .text(e.target.innerText)
        .data('filterVendorTarget', e.target.dataset.filterVendor);

      loadItemsList();
    });

    const loadItemsListDebounced = debounce(loadItemsList);
    $(document).on('keyup', '[data-filter-name-target]', (e) => {
      loadItemsListDebounced();
    });

    $(document).on('change', '[data-trackable-record-id]', ({ target }) => {
      const $button = $('[data-trigger-add-products]');
      const selectedItemsCount = $('input[data-trackable-record-id]:checked').length;
      const suffix = selectedItemsCount > 0 ? ` (${selectedItemsCount})` : '';

      $button.text(`Add Products to Tracker${suffix}`);
    });

    $(document).on('click', '[data-select-all-trackables]', (e) => {
      const $selector = $('input[data-trackable-record-id]');

      $selector.prop('checked', e.target.checked).trigger('change');
    });

    $(document).on('click', '[data-trigger-add-products]', (e) => {
      e.preventDefault();

      const projectId = parseInt($('meta[name=project-id]').attr('content'));
      const records = [];

      $('input[data-trackable-record-id]:checked').each((_index, input) => {
        const { trackableRecordId, trackableRecordType } = input.dataset;

        records.push({ trackable_id: trackableRecordId, trackable_type: trackableRecordType });
      });

      if (records.length === 0) {
        return;
      }

      $.post({
        url: `/projects/${projectId}/order_tracker/xhr_create_order_tracker_items`,
        data: { order_tracker_items: { order_tracker_items_attributes: records } },
        dataType: 'json',
      })
        .done(() => window.location.reload())
        .fail(() => alert('Something went wrong. Please try again.'));
    });

    $('#order-tracker-form').on('click', (e) => {
      const $dropdown = $(e.target).closest('.filter-list__item');
      if (!$dropdown.length && $('.filter-list__item').hasClass('filter-list__item--open')) {
        $('.filter-list__item').removeClass('filter-list__item--open');
      }
    });
  }

  function loadItemsList(resetContent = true) {
    const projectId = parseInt($('meta[name=project-id]').attr('content'));
    const nameFilter = $('[data-filter-name-target]').val();
    const vendorFilter = $('[data-filter-vendor-target]').data('filterVendorTarget');
    const $cont = $('[data-trackables-list-target]');

    if (resetContent) {
      $cont.data('nextPage', 1);
    }
    const nextPage = $cont.data('nextPage');
    if (!nextPage) {
      return;
    }

    unbindInfiniteScrollOvserver();

    $.get({
      url: `/projects/${projectId}/order_tracker/xhr_order_trackables_list`,
      data: {
        order_trackables: {
          query: nameFilter,
          vendor: vendorFilter,
          page: nextPage,
        },
      },
      dataType: 'json',
    })
      .done((data) => {
        const nextPage = data.next_page;
        const trackables = data.trackables;
        $cont.data('nextPage', nextPage);

        bindInfiniteScrollOvserver();

        if (resetContent) {
          $cont.empty().append(trackables);
        } else {
          $cont.append(trackables);
        }
      })
      .fail(() => {
        alert('Something went wrong. Please try again.');
      });
  }

  const saveQuantityDebounced = debounce(($widget, newQuantity) => {
    const projectId = parseInt($('meta[name=project-id]').attr('content'));
    const orderTrackerItemId = $widget.data('order-tracker-item-id');

    $.post({
      url: `/projects/${projectId}/order_tracker/xhr_update_tracker`,
      data: {
        id: orderTrackerItemId,
        order_tracker_item: { qty: newQuantity },
      },
    })
      .done(() => {
        // used in system spec
        $widget.attr('data-spec-saved', true);
      })
      .fail(() => {
        alert('Something went wrong. Please refresh this page and try again.');
      });
  });

  $(document).on('click', '[data-order-tracker-quantity-control]', (e) => {
    e.preventDefault();

    const $el = $(e.target);
    const $widget = $el.closest('[data-quantity-widget]');
    const $quantityField = $widget.find('.order-tracker-form-table__item-quantity-control-input');
    const currentQuantity = parseFloat($widget.data('quantity'));
    const action = $el.data('action');
    let newQuantity = currentQuantity;

    if (action === 'increase') {
      newQuantity = currentQuantity + 1.0;
    } else if (currentQuantity > 1.0) {
      newQuantity = currentQuantity - 1.0;
    }

    // skip http request if quantity is unchanged
    if (currentQuantity === newQuantity) {
      return;
    }

    // reset spec-saved attribute
    $widget.attr('data-spec-saved', false);

    // render the new value
    $quantityField.val(newQuantity.toFixed(1));
    $widget.data('quantity', newQuantity);

    saveQuantityDebounced($widget, newQuantity);
  });

  // Delete order tracker item
  $(document).on('click', '[data-order-tracker-item-remove]', (e) => {
    e.preventDefault();

    const modal = templateContent(document.getElementById('order-tracker-remove-item-template'));
    modal.querySelector('[name="order_tracker_item_id"]').value =
      e.target.closest('tr').dataset.orderTrackerItemId;
    document.body.append(modal);
  });

  $(document).on('click', '[data-order-tracker-item-status-form-url]', (e) => {
    const formUrl = e.target.dataset.orderTrackerItemStatusFormUrl;
    const $form = $(e.target).closest('form');
    const $authField = $form.find('input[name="authenticity_token"]');
    const csrfToken = $('meta[name="csrf-token"]').attr('content');

    $form.attr('action', formUrl);
    $authField.val(csrfToken);
  });

  $(document).on(
    'change keypress blur',
    '.order-tracker-form-table__item-quantity-control-input',
    (e) => {
      const $el = $(e.target);

      if (e.type === 'keypress' && e.key !== 'Enter') {
        return;
      }

      const $widget = $el.closest('[data-quantity-widget]');
      const newQuantity = parseFloat($el.val());

      if (isNaN(newQuantity) || newQuantity < 1) {
        $el.val($widget.data('quantity'));
        return;
      }

      $widget.attr('data-spec-saved', false);
      $widget.data('quantity', newQuantity);

      saveQuantityDebounced($widget, newQuantity);
    }
  );

  const scrollToOrderTrackerItemId = (orderTrackerItemId) => {
    scrollToElement($(`tr[data-order-tracker-item-id="${orderTrackerItemId}"]`));
  };

  const scrollToFirstPoId = (poId) => {
    scrollToElement($(`[data-trackable-po-id="${poId}"]:first`));
  };

  const scrollToElement = ($targetEl) => {
    if ($targetEl.length === 0) {
      return;
    }

    const targetElHeight = $targetEl.height();
    const targetElOffset = $targetEl.offset().top;
    const windowHeight = $(window).height();
    const scrollToOffset = targetElOffset - (windowHeight / 2 - targetElHeight / 2);

    $([document.documentElement, document.body]).animate({ scrollTop: scrollToOffset }, 600);
  };

  // Status Filters

  let activeStatusFilters = [];

  const renderStatusFilterBar = () => {
    const menuItems = [];

    activeStatusFilters.forEach((filter) => {
      menuItems.push(`
        <a class="filter-labels__item filter-labels__item--remove-one filter-labels__item--inline-flex" data-status-filter-clear="${filter.value}">
          ${filter.label}
        </a>
      `);
    });

    if (menuItems.length > 0) {
      menuItems.push(
        '<a class="filter-labels__item filter-labels__item--clear-all" data-status-filter-clear="all">Clear All</a>'
      );

      $('[data-active-status-filters-menu]').html(menuItems);
    } else {
      $('[data-active-status-filters-menu]').empty();
    }
  };

  const updateStatusFilters = () => {
    activeStatusFilters = [];

    $('input[name="status_filter"]').each((_i, input) => {
      if (input.checked && input.value !== 'all') {
        const label = input.nextElementSibling.innerText;
        const value = input.value;

        activeStatusFilters.push({ value, label });
      }
    });

    renderStatusFilterBar();
    toggleOrderTrackerItemsVisibility();
    toggleVendorsVisibility();
  };

  const toggleOrderTrackerItemsVisibility = () => {
    if (activeStatusFilters.length === 0) {
      $('.order-tracker-form-table__source-row').removeClass('hide');
      $('[data-order-tracker-item-status').removeClass('hide');
      return;
    }

    $('.order-tracker-form-table__source-row').addClass('hide');

    $('[data-order-tracker-item-status]').each((_i, itemRow) => {
      const itemStatus = itemRow.dataset.orderTrackerItemStatus;

      if (activeStatusFilters.some((e) => e.value === itemStatus)) {
        const $itemRow = $(itemRow);

        $itemRow.removeClass('hide');
        showHeaderRowForItemRow($itemRow);
      } else {
        itemRow.classList.add('hide');
      }
    });
  };

  const toggleVendorsVisibility = () => {
    $('.order-tracker__vendor').each((_i, vendorRow) => {
      const $vendorRow = $(vendorRow);

      if ($vendorRow.find('tr[data-order-tracker-item-id]:not(".hide")').length > 0) {
        $vendorRow.removeClass('hide');
        // expand vendor row
        $vendorRow
          .find('.order-tracker-header__fold-icon')
          .removeClass('order-tracker-header__fold-icon--closed');
        $vendorRow.find('.order-tracker-form-table-container').removeClass('hide');
        $vendorRow.find('.top-scrollbar').removeClass('hide');
      } else {
        $vendorRow.addClass('hide');
      }
    });
  };

  const showHeaderRowForItemRow = ($itemRow) => {
    let $itemPrevSibling = $itemRow.prev();

    while ($itemPrevSibling.length > 0) {
      if ($itemPrevSibling.hasClass('order-tracker-form-table__source-row')) {
        $itemPrevSibling.removeClass('hide');
        $itemPrevSibling = [];
      } else {
        $itemPrevSibling = $itemPrevSibling.prev();
      }
    }
  };

  const checkStatusFiltersAll = () => {
    $('input[name="status_filter"]').each((_i, input) => {
      input.checked = !!(input.value === 'all');
    });
  };

  const uncheckStatusFilter = (filter) => {
    $(`#status_filter_${filter}`).prop('checked', false);
  };

  $(document).on('change', '[data-filter-status-target]', ({ target }) => {
    const targetStatus = target.dataset.filterStatusTarget;

    if (targetStatus === 'all') {
      checkStatusFiltersAll();
    } else {
      uncheckStatusFilter('all');
    }

    updateStatusFilters();
  });

  $(document).on('click', '[data-close-menu]', ({ target }) => {
    $('.filter-list__item--open').toggleClass('filter-list__item--open');
  });

  $(document).on('click', '[data-status-filter-clear]', (e) => {
    e.preventDefault();

    const clearFilter = e.target.dataset.statusFilterClear;

    if (clearFilter === 'all') {
      checkStatusFiltersAll();
    } else {
      uncheckStatusFilter(clearFilter);
    }

    updateStatusFilters();
  });

  $(document).on('focus', '.search-field', (e) => {
    checkStatusFiltersAll();
    updateStatusFilters();
  });

  // add tooltip to long names
  const orderTrackerTitles = document.querySelectorAll('.order-tracker-form-table__item-title');

  if (orderTrackerTitles.length > 0) {
    orderTrackerTitles.forEach((el) => {
      // cloning element because it's impossible to get it's height if hidden
      const clone = el.cloneNode(true);
      document.getElementById('order-tracker-form').appendChild(clone);
      clone.style.webkitLineClamp = 'unset';
      if (el.offsetHeight < clone.offsetHeight) {
        el.classList.add('tooltip');
        el.innerHTML += `<div class="tooltip__content">${el.innerHTML}</div>`;
        initTooltips(el);
      }
      clone.remove();
    });
  }

  const bindInfiniteScrollOvserver = () => {
    // infinite scroll for trackables
    const observableElement = document.querySelector('[data-load-more-trigger]');

    infiniteScrollObserver.observe(observableElement);
  };

  const unbindInfiniteScrollOvserver = () => {
    const observableElement = document.querySelector('[data-load-more-trigger]');

    if (infiniteScrollObserver && observableElement) {
      infiniteScrollObserver.unobserve(observableElement);
    }
  };
});
